import { Input } from "@/src/components/ui/input";
import type { UseFormReturn } from "react-hook-form";
import type { CheckoutFormData } from "@/src/lib/schemas/checkout-schemas";
import { cn } from "@/src/lib/utils";

interface ContactFormProps {
  form: UseFormReturn<CheckoutFormData>;
}

export function ContactForm({ form }: ContactFormProps) {
  const { register, formState, watch, setValue } = form;
  const errors = formState.errors;

  return (
    <div className="space-y-4 sm:space-y-5 md:space-y-6 bg-white">
      <div
        className="flex items-center"
        style={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "transparent",
          margin: "15px 0px 0px",
          padding: "0px",
          backgroundColor: "transparent",
        }}
      >
        <div>
          <div
            style={{
              color: "rgb(51, 51, 51)",
              fontFamily: "Montserrat",
              lineHeight: 1.2,
              margin: 0,
              padding: "8px 10px",
              textShadow: "transparent 0px 0px 0px",
              fontSize: "16px",
              textAlign: "left",
            }}
            className="text-sm sm:text-base md:text-[18px]"
          >
            <p>
              <strong style={{ color: "rgb(48, 48, 48)" }}>
                STEP 2: CUSTOMER INFORMATION
              </strong>
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 sm:space-y-4">
        <div style={{ margin: "8px 0px 0px" }}>
          <Input
            /*   {...register("firstName")} */
            onChange={(e) => setValue("firstName", e.target.value)}
            value={watch("firstName")}
            placeholder="First name "
            data-address-field="firstName"
            data-type="first_name"
            name="first_name"
            className={cn(
              "h-12 sm:h-14 rounded-lg border-gray-300 text-sm sm:text-base transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
              {
                "border-red-500 focus:border-red-500 focus:ring-red-100":
                  errors.firstName,
              },
            )}
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "rgb(37, 42, 50)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              textAlign: "left",
              fontWeight: "normal",
              fontStyle: "normal",
            }}
          />
          {errors.firstName && (
            <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-red-600">
              {errors.firstName.message}
            </p>
          )}
        </div>
        <div style={{ margin: "8px 0px 0px" }}>
          <Input
            /*   {...register("lastName")} */
            onChange={(e) => setValue("lastName", e.target.value)}
            value={watch("lastName")}
            placeholder="Last name "
            data-address-field="lastName"
            data-type="last_name"
            name="last_name"
            className={cn(
              "h-12 sm:h-14 rounded-lg border-gray-300 text-sm sm:text-base transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
              {
                "border-red-500 focus:border-red-500 focus:ring-red-100":
                  errors.lastName,
              },
            )}
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "rgb(37, 42, 50)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              textAlign: "left",
              fontWeight: "normal",
              fontStyle: "normal",
            }}
          />
          {errors.lastName && (
            <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-red-600">
              {errors.lastName.message}
            </p>
          )}
        </div>
        <div style={{ margin: "8px 0px 0px" }}>
          <Input
            {...register("email")}
            type="email"
            placeholder="Email Address"
            data-address-field="email"
            data-type="email"
            name="email"
            className={cn(
              "h-12 sm:h-14 rounded-lg border-gray-300 text-sm sm:text-base transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
              {
                "border-red-500 focus:border-red-500 focus:ring-red-100":
                  errors.email,
              },
            )}
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "rgb(37, 42, 50)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              textAlign: "left",
              fontWeight: "normal",
              fontStyle: "normal",
            }}
          />
          {errors.email && (
            <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>
        <div style={{ margin: "8px 0px" }}>
          <Input
            {...register("phone")}
            type="tel"
            placeholder="Phone number (optional)"
            data-address-field="phone"
            data-type="phone"
            name="phone"
            className={cn(
              "h-12 sm:h-14 rounded-lg border-gray-300 text-sm sm:text-base transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
              {
                "border-red-500 focus:border-red-500 focus:ring-red-100":
                  errors.phone,
              },
            )}
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "rgb(37, 42, 50)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              textAlign: "left",
              fontWeight: "normal",
              fontStyle: "normal",
            }}
          />
          {errors.phone && (
            <p className="mt-1.5 sm:mt-2 text-xs sm:text-sm text-red-600">{errors.phone.message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
